import $ from 'jquery'
import { Offcanvas, Tooltip } from 'bootstrap'

// eslint-disable-next-line no-undef
const object = vnObject

const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
)
tooltipTriggerList &&
  [...tooltipTriggerList].map((tooltipTriggerEl) => {
    new Tooltip(tooltipTriggerEl)
  })

const menu = document.getElementById('main-nav')
menu && new Offcanvas(menu)

const body = document.body

const setThemeVars = () => {
  const gutter = 12
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  body.style.setProperty('--main-width', `${documentWidth}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  if (mainContainer) {
    const mainContainerWidth = mainContainer.clientWidth

    const col = document.querySelector('.vn-col-sizer')
    const colWidth = col.clientWidth

    body.style.setProperty(
      '--space-width',
      `${(documentWidth - mainContainerWidth) / 2 + gutter}px`
    )

    body.style.setProperty('--container-width', `${mainContainerWidth}px`)
    body.style.setProperty('--col-width', `${colWidth}px`)
  }
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

$('.site-footer__up').on('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
})

const ajaxSearchForms = $('.ajax-search-form')
ajaxSearchForms.each(function () {
  const input = $(this).find('.ajax-search-input')
  const postTypes = $(this).attr('data-post-types')

  input
    .autocomplete({
      minLength: 3,
      appendTo: input.parent().find('.search-form__results'),
      source: function (request, response) {
        $.ajax({
          url: object.ajaxUrl,
          type: 'POST',
          dataType: 'JSON',
          data: {
            _ajax_nonce: object.nonce,
            action: 'vn_get_posts',
            keyword: request.term,
            postType: postTypes,
          },
          success: function (res) {
            response(res.data.data)
          },
        })
      },
      search: function (event) {
        $(event.target)
          .parents('.search-form')
          .addClass('search-form--searching')
      },
      open: function (event) {
        $(event.target).parents('.search-form').addClass('search-form--active')
        $(event.target).addClass('autocomplete-active')
      },
      close: function (event) {
        $(event.target)
          .parents('.search-form')
          .removeClass('search-form--active')
        $(event.target).removeClass('autocomplete-active')
      },
      response: function (event) {
        $(event.target)
          .parents('.search-form')
          .removeClass('search-form--searching')
      },
      create: function () {
        $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
          return $('<li>')
            .append(
              `<a href="${item.url}" data-id="${item.id}" class="ajax-post${
                !item.success ? ' ajax-post--error' : ''
              }">${
                item.thumbnail
                  ? `<img src="${item.thumbnail}" alt="${item.name}">`
                  : ''
              }<div><span class="ajax-post__title">${
                item.title
              }</span><span class="ajax-post__discover">${
                object.readMore
              }</span></div></a>`
            )
            .appendTo(ul)
        }
      },
    })
    .focus(function () {
      $(this).data('uiAutocomplete').search($(this).val())
    })
})
